import React, { ReactNode, useCallback, useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/store';
import { ThunkGetClientPortalPusher } from 'store/common/thunks';
import { IPusherConfig } from 'services/common/types';
import Pusher from 'pusher-js';
import { PusherContext } from 'contexts/pusher';
import { UserDataSelector } from 'store/user';

interface IProps {
  children: ReactNode;
}
const PusherProvider: React.FC<IProps> = ({ children }) => {
  const [pusherConfig, setPusherConfig] = useState<IPusherConfig | undefined>();
  const dispatch = useAppDispatch();
  const user = useAppSelector(UserDataSelector);

  const pusher = useMemo(
    () =>
      pusherConfig ? new Pusher(pusherConfig?.key, { cluster: pusherConfig?.cluster }) : undefined,
    [pusherConfig],
  );

  const onMount = useCallback(() => {
    if (user?.username) {
      dispatch(ThunkGetClientPortalPusher())
        .unwrap()
        .then(res => {
          setPusherConfig(res);
        });
    }
  }, [user]);

  useEffect(() => {
    onMount();
  }, [user]);

  useEffect(() => {
    return () => {
      if (pusher) {
        pusher.allChannels().forEach(ch => {
          pusher.unsubscribe(ch.name);
        });
        pusher.disconnect();
      }
    };
  }, []);

  return <PusherContext.Provider value={{ pusher }}>{children}</PusherContext.Provider>;
};

export default PusherProvider;
